export default __webpack_public_path__ + "static/media/Tiana_9781408349779.c1ce1a92.jpg";